import React, { useState, useEffect } from 'react';
import './Cards.css';

export const ChatOfferCard: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className={`waiting-card chat-offer-card chat-offer-card--placeholder ${isVisible ? 'visible' : ''}`}>
      <div className="chat-offer-card__header">
        <span className="chat-offer-card__icon">💬</span>
        <span className="chat-offer-card__label">Stil Danışmanı</span>
      </div>

      <div className="chat-offer-card__content">
        <p className="chat-offer-card__title">Yardıma mı ihtiyacınız var?</p>
        <p className="chat-offer-card__description">
          Stil danışmanımız yakında burada olacak!
        </p>
        
        <button className="chat-offer-card__btn" disabled>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          <span>Yakında</span>
        </button>
      </div>
    </div>
  );
};

export default ChatOfferCard;
